/**
 * VerseAnalysisResponse — the /v1/verse-analysis verdict for one verse.
 *
 * - none:       KJV and NASB Strong's sequences are identical (or the
 *               difference is below the impact floor) — show nothing
 * - order_only: same numbers and counts in a different order — benign note
 * - problem:    a real difference, rated 1-3 (Minor/Subtil/Major Problem)
 */
import { z } from 'zod';
import { VariantAnalysisSchema } from './variant-analysis.js';
export const VerseAnalysisResponseSchema = z.discriminatedUnion('verdict', [
    z.object({ verdict: z.literal('none') }),
    z.object({ verdict: z.literal('order_only'), note: z.string() }),
    z.object({
        verdict: z.literal('problem'),
        score: z.number().int().min(1).max(3),
        analysis: VariantAnalysisSchema,
    }),
]);
/** Rating titles by score — skjv-mobile vocabulary ("Subtil" is intentional) */
export const PROBLEM_LABELS = {
    1: 'Minor Problem',
    2: 'Subtil Problem',
    3: 'Major Problem',
};
/** Chapter batch: per-verse problem scores (score > 0 only), 1-based verse */
export const ChapterAnalysisResponseSchema = z.object({
    verses: z.array(z.object({ verse: z.number(), score: z.number() })),
});
/** One entry in the all-problems list (1-based coordinates) */
export const ProblemListEntrySchema = z.object({
    testament: z.number(),
    book: z.number(),
    chapter: z.number(),
    verse: z.number(),
    reference: z.string(),
    score: z.number(),
    shortSummary: z.string(),
});
export const ProblemListResponseSchema = z.object({
    problems: z.array(ProblemListEntrySchema),
});
//# sourceMappingURL=verse-analysis.js.map